import { scorePlayerMatch, type PlayerLike } from '@/db/helpers/playerSearchUtils';

export const searchPlayersByName = <T extends PlayerLike>(players: T[], query: string): T[] => {
  const scored = players.flatMap((player) => {
    const match = scorePlayerMatch(player, query);
    return match ? [{ player, score: match.score, norm: match.normalized }] : [];
  });

  scored.sort((a, b) => {
    if (b.score !== a.score) return b.score - a.score;
    if (a.norm.first !== b.norm.first) return a.norm.first.localeCompare(b.norm.first);
    if (a.norm.last !== b.norm.last) return a.norm.last.localeCompare(b.norm.last);
    return Number(a.player.playerId) - Number(b.player.playerId);
  });

  return scored.map(({ player }) => player);
};
